<template>
  <div>
    <slot />
    <LazyCommonChatWidget />
  </div>
</template>
